import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { OrderManipulationView } from "./orderManipulation-view"
import { DistrictSelector } from "../../districts/districtManipulation/districtSelector";
import { PersonnelSearchViewModel } from "../personnel/personnelSearch/personnelSearch-viewModel";

export class OrderManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعیین حکم';
    }
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.orders = ObservableArray.create<singleOrder>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh();

    }
    GetDefaultView(): View <ViewModel> {
        return new OrderManipulationView();
    }
    public getTypeId(): string {
        return "VM-2BA16F74-8A77-4003-94D3-D214A3AAC0C4"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set orders(v: ObservableArray<singleOrder>) { this._orders = v; } public get orders(): ObservableArray<singleOrder> { return this._orders;} private _orders: ObservableArray<singleOrder>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    
    addNew() {
        let inserter = new OrderEditor(this,new InsertServerUpdater());
        inserter.onSuccess = ()=>this.refresh();
        this.showPopup(inserter);
    }
    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelOrderManipulationServices/GetActivePersonnelOrders',{
                FurtherQueryInfo:filteringInformation
            });
            this.orders.update(...result.Orders.map(q=>{
                let r = new singleOrder(this);
                r.id=q.OrderId;
                r.setDistrictInfo(q.DistrictId,q.DistrictName);
                r.setPersonnelInfo(q.PersonnelId,q.PersonnelName,q.PersonnelLastName,q.PersonnelNationalCode,q.PersonnelCode);
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
}


export class singleOrder extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set personnelLastName(v: string) { this._personnelLastName = v; } public get personnelLastName(): string { return this._personnelLastName;} private _personnelLastName: string;
    public set personnelNationalCode(v: string) { this._personnelNationalCode = v; } public get personnelNationalCode(): string { return this._personnelNationalCode;} private _personnelNationalCode: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    

    async invalidate(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('Complex/PersonnelOrderManipulationServices/InvalidatePersonnelOrder',{
                OrderId:this.id
            });
            if(result.IsSuccessful){
                alert("Done");
            }else{
                alert("Failed");
            }
        } catch (ex) {
            console.log(ex);
            alert("Failed");
        } finally {
            this.isLoading = false;
        }
    }
    clone(parent:ViewModel):singleOrder{
        let u = new singleOrder(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(order:singleOrder){
        order.id = this.id;
        order.setPersonnelInfo(this.getPersonnelId(),this.getPersonnelName(),this.getPersonnelLastName(),this.getPersonnelNationalCode(),this.getPersonnelCode());
        order.setDistrictInfo(this.getDistrictId(),this.getDistrictName());
    }
    
    getPersonnelId(): string {
        return this.personnelId;
    }
    getPersonnelName(): string {
        return this.personnelName;
    }
    getPersonnelLastName(): string {
        return this.personnelLastName;
    }
    getPersonnelNationalCode(): string {
        return this.personnelNationalCode;
    }
    getPersonnelCode(): string {
        return this.personnelCode;
    }
    getDistrictId(): string {
        return this.districtId;
    }
    getDistrictName(): string {
        return this.districtName;
    }
    
    setDistrictInfo(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    setPersonnelInfo(id: string, name: string, lastname: string, nationalCode: string,code:string) {
        this.personnelId = id;
        this.personnelName = name;
        this.personnelLastName = lastname;
        this.personnelNationalCode = nationalCode;
        this.personnelCode = code;
    }
}


interface IServerUpdate{
    execute(order:singleOrder):Promise<void>;
}


class InsertServerUpdater implements IServerUpdate{
    
    async execute(order:singleOrder): Promise<void> {
        try {
            let result =  await ServerConnection.callServer('/Complex/PersonnelOrderManipulationServices/UpdatePersonnelOrder',{
                Personnel:order.getPersonnelId(),
                DistrictId:order.getDistrictId(),
            });
            if(result.IsSuccessful==false){
                throw "ERROR";
            }
            order.id=result.Id;        
        } catch (ex) {
            console.log(ex);
            throw ex;
        } finally {
        }
    }
}

export class OrderEditor extends singleOrder implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,updater : IServerUpdate) {
        super(parent);
        this.districtSelector = new DistrictSelector(this);
        this.personnelSelector = new PersonnelSearchViewModel(this);
        this.updater = updater;
    }

    closePopup() {}
    onSuccess(){}

    public set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful;} private _isSuccessful: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    private updater : IServerUpdate;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
    public set personnelSelector(v: PersonnelSearchViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelSearchViewModel;
    
    save(){
        try {
            this.isLoading = true;
            this.updater.execute(this);
            this.isSuccessful = true;            
        } catch (ex) {
            console.log(ex);
            this.isFailed = true;
        } finally {
            this.isLoading = false;
        }
    }

    closeSuccess(){
        this.onSuccess();
        this.closePopup();
    }
    closeFailed(){
        this.isFailed = false;
    }

    getPersonnelId(): string {
        return this.personnelSelector.selectedItem?.id;
    }
    getPersonnelName(): string {
        return this.personnelSelector.selectedItem?.name;
    }
    getPersonnelLastName(): string {
        return this.personnelSelector.selectedItem?.lastName;
    }
    getPersonnelNationalCode(): string {
        return this.personnelSelector.selectedItem?.nationalCode;
    }
    getPersonnelCode(): string {
        return this.personnelSelector.selectedItem?.code;
    }
    getDistrictId(): string {
        return this.districtSelector.selectedItem?.id;
    }
    getDistrictName(): string {
        return this.districtSelector.selectedItem?.title;
    }
    setDistrictInfo(id: string, name: string) {
        this.districtSelector.selectById(id);
    }
    setPersonnelInfo(id: string, name: string, lastname: string, nationalCode: string,code:string) {
        this.personnelSelector.selectById(id);
    }
}